import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import * as S from './action-menu-badge.styles';
import image from './facility.png';
import { generateLabel } from './util';

export interface IFacilityBadgeProps {
    className?: string;
    id?: string;
    name?: string;
    path?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const FacilityBadge: React.FunctionComponent<IFacilityBadgeProps> = (
    props: IFacilityBadgeProps,
): React.ReactElement => {
    const { className, id, name, path, tooltip, items } = props;
    return (
        <ActionMenuBadge
            className={className}
            label={generateLabel('Facility', id, name)}
            path={path || `/facility/${id}`}
            tooltip={tooltip}
            items={items}
            id={id}
            Symbol={<S.ImageSymbol src={image} />}
        />
    );
};
